export const DEFAULT_PATTERN = /^[^\\^/^:^*^?^"^<^>^|]+$/;
export const EMAIL_PATTERN = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;

export const COMPETITION_ID = '5434198a-8b0e-42c6-876d-162daf1a49b2';
